import 'components/ordering/multiple-baskets/basket-form/basket-form.js'
import { html, LitElement, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { BASKET_API, BasketApi } from 'components/ordering/multiple-baskets/basket-api/basket-api.js'
import { SetBasketDeliveryPolicyRequest } from 'components/ordering/multiple-baskets/basket-api/delivery-policy.js'
import {
  BasketCreatedEvent,
  BasketFormFinishedEvent,
  BasketNameChosenEvent,
  BasketNameValidationErrorEvent,
} from 'components/ordering/multiple-baskets/basket-events.js'
import { CreateAdditionalBasketRequest, } from 'components/ordering/multiple-baskets/basket-api/create-additional-basket.js'
import { CreateAdditionalBasketFailure, DeliveryPolicy } from 'components/ordering/acl/internal-types.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { WINDOW_LOCATION, WindowLocation } from '@cloudsuite/mosaic-shared/scripts/window-location.js'


@customElement('csc-basket-creator')
export class CSCBasketCreator extends LitElement {
  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @property({ type: Number, attribute: 'party-id' })
  partyId = 0

  @property({ type: Number, attribute: 'user-id' })
  userId: number | null = null

  @property({ type: Number, attribute: 'shop-id' })
  shopId = 0

  @inject(BASKET_API)
  private basketApi!: BasketApi

  @inject(WINDOW_LOCATION)
  private windowLocation!: WindowLocation

  constructor() {
    super()

    this.addEventListener(BasketFormFinishedEvent.type, this.handleSave)
  }

  private async handleSave(e: BasketFormFinishedEvent) {
    const createAdditionalBasketResponse = await this.createBasket(e)
    if (createAdditionalBasketResponse instanceof CreateAdditionalBasketFailure) {
      window.dispatchEvent(new BasketNameValidationErrorEvent(createAdditionalBasketResponse.reason))
      return
    }
    await this.setDeliveryPolicy(
      createAdditionalBasketResponse.basketId,
      e.selectedDeliveryPolicy
    )
    this.finishCreation()
  }

  private createBasket = async (event: BasketNameChosenEvent) => {
    const request = new CreateAdditionalBasketRequest(
      this.orderingEndpoint,
      this.partyId,
      this.shopId,
      event.name,
    )

    return await this.basketApi.createAdditionalBasket(request)
  }

  private setDeliveryPolicy = async (basketId: string, selectedDeliveryPolicy: DeliveryPolicy) => {
    const setBasketDeliveryPolicyRequest = new SetBasketDeliveryPolicyRequest(
      this.orderingEndpoint,
      this.shopId,
      basketId,
      selectedDeliveryPolicy,
    )

    await this.basketApi.setBasketDeliveryPolicy(setBasketDeliveryPolicyRequest)
  }

  private finishCreation = () => {
    this.dispatchEvent(new BasketCreatedEvent())
    this.windowLocation.reload()
  }

  protected override render(): TemplateResult {
    return html`
      <csc-basket-form
        ordering-endpoint="${this.orderingEndpoint}"
        party-id="${this.partyId}"
        shop-id="${this.shopId}"
      ></csc-basket-form>
    `
  }
}
